import { useTranslation } from "react-i18next";
import { HTMLAttributes } from "react";

import { Button, ButtonVariant } from "@industriousoffice/react-components";
import { useNavigate } from "react-router-dom";
import { Account, Location } from "@/api/opb/opbTypes";
import { getFullPath } from "@/router/utils/getFullPath";
import { slugs } from "@/router/slugs";

interface IncorrectBankInfoBannerProps extends HTMLAttributes<HTMLDivElement> {
  account: Account;
  location?: Location;
}

export function IncorrectBankInfoBanner({
  account,
  className = "",
  location,
  ...props
}: IncorrectBankInfoBannerProps) {
  const { t } = useTranslation("dashboard");
  const navigate = useNavigate();

  const navigateToSecurityDepositForm = () => {
    navigate(getFullPath(slugs.securityDeposit, { accountId: account._id }));
  };

  const name = location
    ? `${location.city} — ${location.name}`
    : account.globalAccountName;

  return (
    <div
      className={`rounded-lg py-3 px-5 bg-honey-99 text-sm shadow-card ${className}`}
      {...props}
    >
      <div className="font-bold" data-testid="incorrect_bank_info_banner-title">
        {name}
      </div>
      <div className="flex mt-2 items-center sm:flex-row flex-col">
        <div className="mr-4">
          {t(
            "We are unable to process your security deposit refund because the bank account information you provided is incorrect. Please update your bank account information."
          )}
        </div>
        <Button
          variant={ButtonVariant.Outline}
          onClick={navigateToSecurityDepositForm}
          data-testid="security_deposit_banner-btn"
          className="whitespace-nowrap bg-transparent! border-2 border-grey-30! text-black! mt-4 sm:mt-0 sm:w-fit w-full"
        >
          {t("Go to Security Deposit Form")}
        </Button>
      </div>
    </div>
  );
}
